// @ts-check
import LocationInfoCard from './LocationInfoCard';

export default LocationInfoCard;
